import React from 'react';
import timeLockedReasons from '~/routes/app/time/timeLockedReasons';
import Tooltip from './Tooltip';
import LockIcon from './LockIcon';

function TimeLockIcon({ value, ...props }) {
  const locked = value !== 'unlocked';

  if (!locked) return null;

  const tooltip = timeLockedReasons[value];

  return (
    <Tooltip message={tooltip}>
      <LockIcon {...props} />
    </Tooltip>
  );
}

export default TimeLockIcon;
